import React from "react";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import FasesAcontecimento from "components/FasesAcontecimento";
import CardUtilizador from "components/CardUtilizador";

import withStyles from "@material-ui/core/styles/withStyles";
import percursosStyle from "assets/jss/material-dashboard-pro-react/views/percursosStyle";
import {faCheck, faEye, faFileSignature, faSpinner, faStopwatch, faUserCheck} from "@fortawesome/free-solid-svg-icons";
import general from "../../../general";
import Button from "../../../components/CustomButtons/Button";
import SweetAlert from "../../../components/SweetAlertWrapper";
import connection from "../../../connection";
import StateCircle from "../../../components/StateCircle";
import Tooltip from "@material-ui/core/Tooltip";
import AccessTime from "@material-ui/icons/AccessTime";
import EstadoParticipacaoCurso from "../../../components/EstadoParticipacaoCurso";

import PaginaCurso from "../PaginaCurso";
import ConfirmarRegisto from "../../../components/ConfirmarRegisto/ConfirmarRegisto";

class VisualizacaoPercurso extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      percurso: props.detalhes,
      cursos: [],
      modal: null
    };

    this.hideModal = this.hideModal.bind(this);

    this.reloadCursos = async () => {
      this.setState({
        cursos: await connection.get("percurso/curso/listagem_disponiveis", {
          percurso: this.state.percurso.id
        })
      });
    };
  }

  static getDerivedStateFromProps(props, state) {
    return {percurso: props.detalhes};
  }

  componentDidMount() {
    this.reloadCursos();
  }

  hideModal() {
    this.setState({
      modal: null
    })
  }

  render() {
    const {classes, location} = this.props;
    const {percurso} = this.state;

    return <div className={classes.cursosContainer}>
      <div className={classes.eventLabel}>
        <p>Percurso</p>
        <h2>{percurso.designacao}</h2>
      </div>
      <FasesAcontecimento acontecimento={this.state.percurso} fases={[
        {
          field: "data_ativacao",
          descripion: ["Publicado", "Publicado"],
          icon: faEye
        },
        {
          field: "data_abertura_registos",
          descripion: ["Abertura de candidaturas", "Candidaturas abertas"],
          icon: faFileSignature
        },
        {
          field: "data_limite_registos",
          descripion: ["Limite para candidaturas", "Candidaturas fechadas"],
          icon: faStopwatch
        },
        {
          field: "data_registos_fechados",
          descripion: ["Seleção de candidaturas", "Participantes selecionados"],
          icon: faUserCheck
        },
        {
          field: "data_inicio_curso",
          descripion: ["Início do percurso", "Percurso a decorrer"],
          icon: faSpinner
        },
        {
          field: "data_fecho",
          descripion: ["Fim do percurso", "Percurso terminado"],
          icon: faCheck
        },
      ]}/>
      {this.state.modal}
      <GridContainer>
        <GridItem xs={12} sm={8}>
          <Card>
            <CardHeader color="primary">
              <h4 style={{flex: 1}}>Informações</h4>
            </CardHeader>
            <CardBody className={classes.courseDetails}>
              <GridContainer>
                {/*<GridItem xs={12} sm={4}>
                  <div className={classes.itemDetalhes}>
                    <h4>{percurso.agrupamento}</h4>
                    <p>Agrupamento</p>
                  </div>
                </GridItem>*/}
                <GridItem xs={12} sm={4}>
                  <div className={classes.itemDetalhes}>
                    <h4>{percurso.nucleo}</h4>
                    <p>Núcleo</p>
                  </div>
                </GridItem>
                <GridItem xs={12} sm={4}>
                  <div className={classes.itemDetalhes}>
                    <h4>{percurso.regiao}</h4>
                    <p>Região</p>
                  </div>
                </GridItem>
                <GridItem xs={12} sm={4}>
                  <div className={classes.itemDetalhes}>
                    <h4>{percurso.vagas_livres}</h4>
                    <p>Vagas</p>
                  </div>
                </GridItem>
                {percurso.imaginario_mistica && <GridItem xs={12}>
                  <div className={classes.outrosDetalhes}>
                    <h4>Imaginário Mística</h4>
                    <p>{percurso.imaginario_mistica}</p>
                  </div>
                </GridItem>}
                {percurso.patrulhas_metodo && <GridItem xs={12}>
                  <div className={classes.outrosDetalhes}>
                    <h4>Patrulhas Método</h4>
                    <p>{percurso.patrulhas_metodo}</p>
                  </div>
                </GridItem>}
              </GridContainer>
            </CardBody>
          </Card>
          <Card>
            <CardHeader color="primary">
              <h4 style={{flex: 1}}>Cursos</h4>
            </CardHeader>
            <CardBody className={classes.percursoDetails} style={{paddingLeft: 0, paddingRight: 0}}>
              {this.state.percurso.tipo_cursos.map((tipo_curso) => {
                let cursos_filtrado = this.state.cursos.filter((curso)=>curso.tipo === tipo_curso.codigo);
                return <React.Fragment>
                  <div className={classes.tipoCursoHeaderContainer}>
                    <h3 style={{margin: 0, fontSize: "18px"}}>{tipo_curso.designacao}</h3>
                  </div>
                  <div className={classes.tipoCursoAccordionWrapper}>
                    <GridContainer>
                      {cursos_filtrado.length === 0 ?
                        <span style={{width: "100%", display: "block",textAlign:"center"}}>Ainda não existem cursos do tipo {tipo_curso.codigo} disponíveis.</span>
                        : cursos_filtrado.map((curso)=>{
                          let estadoParticipacao = {resultado: (curso.utilizador_registado && !curso.estado_participacao) ? {codigo: "REG", designacao: "Registado"} : curso.estado_participacao};
                        return <GridItem xs={12} sm={6} lg={4} key={"curso_" + curso.id}>
                          <div className={classes.cursoCardContainer}>
                            <div style={{float:"right"}}><EstadoParticipacaoCurso tooltipPlacement={"left"} estado={estadoParticipacao}/></div>
                            <p className={classes.cursoCardPrice}>{curso.preco_inscricao ? (curso.preco_inscricao + "€") : "Gratuito"}</p>
                            <p className={classes.cursoCardTitle}><StateCircle tooltipPlacement={"top"} state={curso.estado}/>{curso.descricao}</p>
                            <hr style={{margin: "12px 0"}}/>
                            <div>
                              {curso.data_inicio_curso ? <Tooltip
                                title={<small style={{whiteSpace: "pre"}}> (<span style={{top: 2, position: "relative"}}><AccessTime fontSize={"inherit"}/></span> {general.guessTimezone().trans})</small>}
                                placement="top"
                                classes={{tooltip: classes.tooltip}}
                              >{general.Renderers.dateRenderer(curso.data_inicio_curso, {hide_timezone: true})}</Tooltip> : null}
                            </div>

                            <span>{curso.local} {curso.regiao && ((curso.local ? "(" : "") + curso.regiao + (curso.local ? ")" : ""))}</span>
                            <div style={{textAlign: "center", paddingTop: "5px"}}>
                              <Button className={classes.button + " " + classes.info + " " + classes.sm} size="sm" onClick={() => {
                                curso.utilizador_registado ?
                                  window.open("/curso/" + curso.id)
                                : window.App.openModal(<SweetAlert
                                  showClose
                                  style={{width: 1200, padding: 40, backgroundColor: "#EEEEEE"}}
                                  onConfirm={() => window.App.hideModal()}
                                  onCancel={() => window.App.hideModal()}
                                  confirmBtnText="Fechar"
                                  confirmBtnCssClass={
                                    classes.button + " " + classes.primary + " " + classes.buttonConfirm
                                  }>
                                  <PaginaCurso id_curso={curso.id} visualizacao/>
                                </SweetAlert>);
                              }}>Ver Curso</Button>
                            </div>
                          </div>
                        </GridItem>
                      })}
                    </GridContainer>
                  </div>
                </React.Fragment>
              })}
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={4}>
          <CardUtilizador compact utilizador={percurso.diretor} label={"Diretor do percurso"} pode_ver_utilizador={percurso.diretor.pode_ver_formador}/>
          <ConfirmarRegisto acontecimento={percurso} designacao={`percurso ${percurso.designacao}`} dados={{percurso: percurso.id, aceitacao: false}} reloadDetalhes={this.props.reloadDetalhes}/>
        </GridItem>
      </GridContainer>
    </div>;
  }
}

export default withStyles(percursosStyle)(VisualizacaoPercurso);